/* global axios */
import ApiClient from '../ApiClient';

// Impacto da IA (R2.14): atendidas/resolvidas/transbordadas por assunto.
class BotImpactAPI extends ApiClient {
  constructor() {
    super('fandata/bot_impact', { accountScoped: true });
  }

  // T-252: só canal. Esta tela mede o que passou pelo Bira, então recortar por lado a
  // esvaziaria com um filtro que parece ter funcionado.
  get({ since, until, inboxId } = {}) {
    return axios.get(this.url, { params: { since, until, inbox_id: inboxId } });
  }

  // T-169/T-171: os atendimentos por trás do número, por motivo.
  casos({ since, until, motivo } = {}) {
    return axios.get(`${this.url}/casos`, { params: { since, until, motivo } });
  }

  // T-190c: os quatro motivos num arquivo, sem o corte da tela, para a planilha.
  casosPlanilha({ since, until } = {}) {
    return axios.get(`${this.url}/casos_planilha`, { params: { since, until } });
  }
}

export default new BotImpactAPI();
